import { BaseWidgetFormFields } from 'components/consumer-page-widgets/BaseWidgetFormFields';
import { Button, Typography } from 'ui';
import {
  CardLinkWidgetFields,
  CardLinkWidgetFormFields,
} from 'components/consumer-page-widgets/card-link-widget/CardLinkWidgetFormFields';
import { Form, Formik } from 'formik';
import { Widgets } from '@tock/shared/types/widget';
import {
  getBaseFormFieldsInitialValues,
  useCreateNamedConfigurations,
} from 'components/consumer-page-widgets/widgetFormUtils';
import {
  widgetFormButtonContainer,
  widgetFormRoot,
} from 'components/consumer-page-widgets/widgetFormCssDefs';
import React, { FunctionComponent } from 'react';

interface CreateCardLinkWidgetFormProps {
  onCompleteOrCancel(): void;
}

export const CreateCardLinkWidgetForm: FunctionComponent<
  React.PropsWithChildren<CreateCardLinkWidgetFormProps>
> = ({ onCompleteOrCancel }) => {
  const createNamedConfig = useCreateNamedConfigurations();

  const handleSubmit = ({
    name,
    imageAlt,
    imageUrl,
    tagline,
    linkText,
    linkHref,
    variant,
  }: CardLinkWidgetFields) => {
    return createNamedConfig({
      name: name,
      widgetType: Widgets.WidgetCreatorWidgetType,
      cardLinkWidgetConfig: {
        imageAlt: imageAlt,
        imageUrl: imageUrl,
        tagline: tagline,
        linkText: linkText,
        linkHref: linkHref,
        variant: variant,
      },
    }).then(onCompleteOrCancel);
  };

  return (
    <>
      <Typography variant="heading1Bold">Create widget</Typography>
      <Formik<CardLinkWidgetFields>
        enableReinitialize
        initialValues={{
          ...getBaseFormFieldsInitialValues(),
          imageUrl: '',
          imageAlt: '',
          tagline: '',
          linkText: '',
          linkHref: '',
          variant: 'DEFAULT',
        }}
        onSubmit={handleSubmit}
      >
        <Form css={widgetFormRoot}>
          <BaseWidgetFormFields />
          <CardLinkWidgetFormFields />
          <div css={widgetFormButtonContainer}>
            <Button type="submit">Submit</Button>
            <Button variant="outlined" type="button" onClick={onCompleteOrCancel}>
              Cancel
            </Button>
          </div>
        </Form>
      </Formik>
    </>
  );
};
